"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _reactTooltip = _interopRequireDefault(require("react-tooltip")),
    _appendToBody = _interopRequireDefault(require("../../common/hoc/appendToBody"));

require("./_tooltip.scss");

var TooltipBase = function TooltipBase(a) {
  var b = a.id,
      c = a.label,
      d = a.place;
  return _react["default"].createElement(_reactTooltip["default"], {
    id: b,
    effect: "solid",
    delayShow: 300,
    className: "tooltip",
    place: d
  }, _react["default"].createElement("span", null, c));
},
    BodyTooltip = (0, _appendToBody["default"])(TooltipBase);

function ToolTip(a) {
  var b = a.label,
      c = a.id,
      d = a.place,
      e = a.children;
  return c && b ? _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(BodyTooltip, {
    id: c,
    label: b,
    effect: "solid",
    place: d
  }), _react["default"].cloneElement(e, {
    "data-tip": !0,
    "data-for": c
  })) : e;
}

var _default = (0, _react.memo)(ToolTip);

exports["default"] = _default;